var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1733733163298,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1210,
    id: "mx_n_1733733163299",
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.1 131.2c-97.6 0-176.7 79.1-176.7 176.7s79.1 176.7 176.7 176.7h176.7V307.9c0-97.5-79.1-176.7-176.7-176.7zM893.5 307.9c0-97.6-79.1-176.7-176.7-176.7s-176.7 79.1-176.7 176.7v176.7h176.7c97.6 0 176.7-79.1 176.7-176.7zM132.4 715.7c0 97.6 79.1 176.7 176.7 176.7s176.7-79.1 176.7-176.7V539H309.1c-97.6 0-176.7 79.1-176.7 176.7zM716.9 539H540.2v176.7c0 97.6 79.1 176.7 176.7 176.7s176.7-79.1 176.7-176.7S814.4 539 716.9 539z",
    fill: "#46766a",
    "p-id": 1211
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/表型管理2.785085d6628bfac03dfdc17d4b4e03ef.svg";
export { ForwardRef as ReactComponent };